import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { BetStatus, useTranslation } from '@pascal/pascal-core';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../store/gameStore';
import { gameLiveConnection } from '../../services';
import { winningStore } from '../../store/winningStore';
import { soundService, soundTypes } from '../../services/SoundService';

export const Cashout = observer(({ isDisable }) => {
  const { roundStatus, betId, isAllowSendToInvoke, setIsAllowSendToInvoke } = gameStore;
  const { winCombination } = winningStore;
  const { isDemo } = applicationStore;
  const t = useTranslation();

  const handleCashOut = useCallback(() => {
    if (roundStatus === BetStatus.Pending && winCombination) {
      setIsAllowSendToInvoke(false);
      soundService.play(soundTypes.cashout);
      if (isDemo) {
        gameLiveConnection.doDemoCashout();
      } else {
        gameLiveConnection.doCashOut(betId);
      }
    }
  }, [roundStatus, winCombination, setIsAllowSendToInvoke, isDemo, betId]);

  return (
    <div
      className={`money-button-container ${
        roundStatus === BetStatus.Pending && isAllowSendToInvoke && winCombination && !isDisable
          ? ''
          : 'inactive'
      }`}
      title={t('CASHOUT')}
      onClick={handleCashOut}
    >
      {/* added/remove class inactive */}
      <div
        className={`money-button ${
          roundStatus === BetStatus.Pending && isAllowSendToInvoke && winCombination && !isDisable
            ? 'pulse-anim'
            : ''
        }`}
      >
        <i className='icon-tp-cashout' />
      </div>
    </div>
  );
});
